import { createElement } from 'react';
import { BorderBox1, BorderBox2, BorderBox3, BorderBox4, BorderBox5, BorderBox6, BorderBox7, BorderBox8, BorderBox9, BorderBox10, BorderBox11, BorderBox12, BorderBox13, } from '@jiaminghi/data-view-react';
const DataVBorderBox = (props) => {
    const { children, borderType = '1', ...rest } = props;
    const ComponentMaps = {
        '1': BorderBox1,
        '2': BorderBox2,
        '3': BorderBox3,
        '4': BorderBox4,
        '5': BorderBox5,
        '6': BorderBox6,
        '7': BorderBox7,
        '8': BorderBox8,
        '9': BorderBox9,
        '10': BorderBox10,
        '11': BorderBox11,
        '12': BorderBox12,
        '13': BorderBox13,
    };
    const BorderBox = ComponentMaps[borderType];
    return createElement(BorderBox, { ...rest }, children);
};
export default DataVBorderBox;
